import { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { HistoricalAlbaranesTable } from '../../components/albaranes/HistoricalAlbaranesTable'
import albaranesService from '../../services/albaranes.service'
import { Alert, Box, Button, Stack } from "@mui/material";
import { Link } from 'react-router-dom';
import { Field, Form, Formik } from 'formik'
import DateRangePicker from '../../components/common/forms/dateRangePicker'

export default function HistoricalAlbaranes() {
  const [rowsState, setRowsState] = useState({
    page: 0,
    pageSize: 50,
    total: 0,
    rows: [],
    loading: true,
    date_from: null,
    date_to: null,
  })

  const [range, setRange] = useState({
    date_from: rowsState.date_from,
    date_to: rowsState.date_to,
  });

  const monthsAgo = (months) => {
    const date = new Date();
    date.setMonth(date.getMonth() - months);
    date.setHours(0, 0, 0, 0);
    return date;
  }
  
  const minDate = monthsAgo(3);
  const maxDate = new Date();

  const onChangeRange = (value) => {
    setRange({
      date_from: value[0]?.getTime() || null,
      date_to: value[1]?.getTime() || null,
    });
  };

  const handleSubmit = () => {
    setRowsState((prev) => ({
      ...prev,
      page: 0,
      date_from: range.date_from,
      date_to: range.date_to,
    }));
  };

  useEffect(() => {
    let active = true;

    setRowsState(prev => ({ ...prev, loading: true }));

    (async () => {
      const results = await albaranesService.getAll({
        page: rowsState.page + 1,
        per_page: rowsState.pageSize,
        archive: true,
        date_from: rowsState.date_from,
        date_to: rowsState.date_to,
      });

      if (!active) return;

      setRowsState(prev => ({
        ...prev,
        loading: false,
        rows: results?.albaranes || [],
        total: results?.total || 0,
      }));
    })();

    return () => {
      active = false;
    };
  }, [rowsState.page, rowsState.pageSize, rowsState.date_from, rowsState.date_to]);

  return (
    <>
      <Stack direction="row" spacing={2} sx={{ justifyContent: "space-between", alignItems: "center", my: 2 }}>
        <h3 style={{ margin: 0 }}>Histórico</h3>
        <Button
          component={Link}
          to="/albaranes"
          variant="contained"
          color="info"
          size="small"
        >
          Devoluciones
        </Button>
      </Stack>
      <Helmet>
        <title>Devoluciones - Marina BCN</title>
      </Helmet>
      <Alert sx={{ mb: 3 }} severity="info">Histórico disponible: últimos 3 meses</Alert>
      <Box sx={{ my: 2 }}>
        <Formik initialValues={rowsState} onSubmit={handleSubmit}>
          <Form>
            <Field
              component={DateRangePicker}
              onChangeRange={onChangeRange}
              dateFromFieldName="date_from"
              dateToFieldName="date_to"
              startText="Fecha inicio"
              middleText="hasta"
              endText="Fecha fin"
              minDate={minDate}
              maxDate={maxDate}
              initialRangeValue={[
                rowsState.date_from ? new Date(rowsState.date_from) : null,
                rowsState.date_to ? new Date(rowsState.date_to) : null,
              ]}
            />
            <Button type="submit" variant="contained" sx={{ mt: 2 }} color="secondary">
              Buscar
            </Button>
          </Form>
        </Formik>
      </Box>
      <HistoricalAlbaranesTable rowsState={rowsState} setRowsState={setRowsState} />
    </>
  )
}
